import { setSmartlookEvent } from "@/utils/smartlook";

const ONBOARDING_SUBMIT_EVENT_BY_PATH: Record<string, string> = {
  "/profiling/step-user-details": "onboarding_submit_user_details",
  "/profiling/step-user-status": "onboarding_submit_user_status",
  "/profiling/step-lifestyle": "onboarding_submit_lifestyle",
  "/profiling/step-dietary-preferences": "onboarding_submit_dietary_preferences",
  "/profiling/step-food-avoids": "onboarding_submit_food_avoids",
  "/profiling/step-supermarket": "onboarding_submit_supermarket",
  "/profiling/step-activity-level": "onboarding_submit_activity_level",
};

export const setSmartlookOnboardingEvent = ({
  type,
  stepPath,
}: {
  type: "submit" | "completed";
  stepPath?: string;
}) => {
  if (type === "completed") {
    setSmartlookEvent("onboarding_completed", {
      completed: true,
    });
    return;
  }

  if (!stepPath) return;
  const eventName = ONBOARDING_SUBMIT_EVENT_BY_PATH[stepPath];
  if (!eventName) return;

  setSmartlookEvent(eventName, {
    step_path: stepPath,
  });
};
